module.exports = {
      id: "arrow-right-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }